<div class="agu-scale" role="radiogroup" [attr.aria-labelledby]="LabelledBy" [attr.aria-required]="Required ? 'true' : null" [class.agu-scale--disabled]="Disabled">
  @for (o of Options; track o.Value; let i = $index) {
    <label class="agu-scale__row" [class.agu-scale__row--on]="IsSelected(o)" [for]="OptionID(i)">
      <input class="agu-scale__input" type="radio" [id]="OptionID(i)" [name]="Name" [value]="o.Value"
             [checked]="IsSelected(o)" [disabled]="Disabled" (change)="Select(o.Value)" />
      <span class="agu-scale__dot" aria-hidden="true"></span>
      <span class="agu-scale__text">
        <span class="agu-scale__label">{{ o.Label }}</span>
        @if (o.Description.length > 1) {
          <span class="agu-scale__desc agu-scale__desc--list" role="list">@for (d of o.Description; track $index) {<span class="agu-scale__item" role="listitem">{{ d }}</span>}</span>
        } @else {
          <span class="agu-scale__desc">{{ o.Description[0] ?? '' }}</span>
        }
      </span>
    </label>
  }
</div>
